export const blockIconsNotificationEnhancedEncryption = (
	<span className='material-symbols-outlined'>enhanced_encryption</span>
);
